import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformGuard {

  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    // AuthGuard runs first in the canActivate chain and handles the
    // unauthenticated case (redirect to /login). By the time this guard
    // runs, the user is known to be logged in — we only need to check
    // the super-user flag.
    //
    // auth.user is a BehaviorSubject that replays its current value
    // synchronously on subscribe; take(1) + toPromise auto-unsubs after
    // the first emission so we don't leak a Subscription.
    const user = await this.auth.user.pipe(take(1)).toPromise();
    if (user && user.is_super_user) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
